export default "__VITE_ASSET__51b39e59__"